import { Unionize } from "./generic";

export const TaskState = ["PENDING", "IN_PROGRESS", "COMPLETE", "ERROR"] as const;
export type TaskState = Unionize<typeof TaskState>;

export type TaskStatus = {
  Progress: number | null;
  State: TaskState;
  Definition: TaskDefinition | null;
};

export type TaskDefinitionStage = {
  Key: string;
  State: TaskState;
};

export type TaskDefinition = {
  Stages: TaskDefinitionStage[];
};

export type Task = { ID: string } & TaskStatus;

export type StageStatus = "Success" | "Error" | "InProgress" | "Idle" | "Cancelling" | "NotReady";

export type TaskStage = {
  key: string;
  status: StageStatus;
};

/**
 * System task type returned by the superuser tasks API
 */
export type SystemTask = Task & {
  SystemWorkflow: {
    ID: string;
  };
  Key: string;
  UpdateTime: string;
  StartTime: string;
  EndTime: string | null;
  ErrorMessage: string | null;
};
